var render = function render(){var _vm=this,_c=_vm._self._c;return _c('riseup-button',{staticClass:"dd-button",attrs:{"title":_vm.title,"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.action}})
}
var staticRenderFns = []

export { render, staticRenderFns }